import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/gift_list',
    ADD: '/content/gift_add',
    UPDATE: '/content/gift_update',
	SET_DISABLED: '/content/gift_set_enable',
    IS_EXIST_ACCOUNT: '/content/gift_is_exist_gift_name',
}

export async function giftList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function giftAdd(form) {
    return requestPost(api.ADD, form);
}

export async function giftUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function giftSetEnabled(id, enable) {
    let params = {
        id: id,
        enable: enable
    };
    return requestPost(api.SET_DISABLED, params);
}

export async function giftNameIsExist(account) {
    let params = {val: account};
    return requestGet(api.IS_EXIST_ACCOUNT, params);
}

